import {
  FontAwesomeIcon,
  IconProp,
  GrcSkeleton,
  GrcSkeletonVariant
} from '@grc/ui-package';
import { formatNumber, tabEvents } from '@grc/ui-utility';
import { IOperationalStatCardProps } from './operational-stat-card.interface';
import './operational-stat-card.scss';

export default function OperationalStatCard({
  title,
  icon,
  sections,
  isLoading,
  onSectionClick
}: IOperationalStatCardProps) {
  const testId = title.toLowerCase().replace(/\s+/g, '_');

  return (
    <div
      className="operational-stat-card"
      role="group"
      aria-label={title}
      data-testid={`${testId}_card`}
    >
      <div className="operational-stat-card-header d-flex align-items-center">
        <span className="operational-stat-card-icon d-flex align-items-center justify-content-center">
          <FontAwesomeIcon icon={icon as IconProp} />
        </span>
        <h6 className="operational-stat-card-title mb-0 ms-2">{title}</h6>
      </div>

      <div className="operational-stat-card-body d-flex flex-column">
        {isLoading ? (
          <GrcSkeleton variant={GrcSkeletonVariant.Rectangular} height={72} />
        ) : (
          sections.map((section, index) => (
            <div
              key={section.key}
              role="button"
              tabIndex={0}
              className={`operational-stat-card-section text-center${
                index > 0 ? ' operational-stat-card-section-divided' : ''
              }`}
              onClick={() => onSectionClick?.(section.key)}
              {...tabEvents()}
              aria-label={`${section.label}, ${formatNumber(section.value)}`}
            >
              <span className="operational-stat-card-label d-block">
                {section.label}
              </span>
              <span className="operational-stat-card-value d-block">
                {formatNumber(section.value)}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
